import { AngularFireAuth } from "@angular/fire/auth";
import { AuthService } from "../../services/auth.service";
import { AbstractControl, ValidatorFn } from "@angular/forms";

export function configurationFactory(
  afAuth: AngularFireAuth,
  authSer: AuthService
  ): () => Promise<any> {
    return (): Promise<any> => {
      return new Promise((resolve, reject) => {
        afAuth.authState.subscribe(user => {
          if (user) {
            authSer.userData = JSON.stringify(user);
            if (!localStorage.getItem('user')) {
              localStorage.setItem('user', authSer.userData );
              authSer.userData = JSON.parse(authSer.userData)
            } else {
              authSer.userData = JSON.parse(localStorage.getItem('user'))
            }
          
          } else {
            console.log('');
            console.log('');
            console.log('gettting in here ');
            console.log('');
            console.log('');
            localStorage.setItem('user', '');
            JSON.parse(localStorage.getItem('user') || '{}');
          }
          resolve(true);
        })
      }); 
    };
  }


// Function to validate Google Maps link
export const googleMapsLinkValidator: ValidatorFn = (control: AbstractControl) => {
  if (!!control.value) {
    const regex = /^(https?:\/\/)?(www\.)?(google\.com\/maps\/place|maps\.app\.goo\.gl)\/[^\/\s]+/i;
    const isValid = regex.test(control.value);
    return isValid ? null : { invalidGoogleMapsLink: true };
  } else {
    return null
  }
};